import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WifiRoutingModule } from './wifi-routing.module';
import { WifiLandingPageComponent } from './wifi-landing-page/wifi-landing-page.component';
import { WifiLinkComponent } from './wifi-link/wifi-link.component';
import { WifiStudentDetailsComponent } from './wifi-student-details/wifi-student-details.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import {MatSelectModule} from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { WifistudentDialogComponent } from './wifistudent-dialog/wifistudent-dialog.component';
import { MatCardModule } from '@angular/material/card';


@NgModule({
  declarations: [
    WifiLandingPageComponent,
    WifiLinkComponent,
    WifiStudentDetailsComponent,
    WifistudentDialogComponent,

  ],
  imports: [
    CommonModule,
    WifiRoutingModule,
    AcademicFormModule,
    MatSelectModule,
    FormsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    MatCardModule

  ]
})
export class WifiModule { }
